import { SingleLayout } from './SingleLayout';
export default SingleLayout;
